var subnavBlock = {
    $subnav: $('.subnav-block'),
    currTop: 0,
    backPosition: 0,

    init: function() {
        var _this = this;

        if (!_this.$subnav.length) {
            return;
        }

        _this.backPosition = document.getElementById('terugreis').offsetTop;
        _this.checkPos();

        $(window).on('scroll', function() {
            _this.checkPos();
        });
    },
    checkPos: function() {
        var _this = this,
            top = document.documentElement.scrollTop || document.body.scrollTop;

        //stickyMenu toggle
        if (top > _this.backPosition && _this.currTop < _this.backPosition) {
            _this.toggleActive('terug');
        } else {
            _this.toggleActive('heen');
        }
    },
    toggleActive: function(className) {
        var _this = this;

        if (className == 'heen') {
            $('.nav-item.heen').addClass('active');
            $('.nav-item.terug').removeClass('active');
        } else {
            $('.nav-item.heen').removeClass('active');
            $('.nav-item.terug').addClass('active');
        }
    }
};
